module.exports = __webpack_public_path__ + "img/wave_top_bracelet.112edd4d.png";